<div class="page mx-auto w-full px-4 py-12 sm:max-w-[540px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1140px] 2xl:max-w-[1320px]">
  <app-loading [show]="isLoading"></app-loading>
  <div class="flex justify-between items-center mb-6">
    <div class="flex items-center">
      <img src="assets/images/Sphynx_Main_Logo_white_background.svg" alt="SPHYNX Logo" style="height: 120px" />
    </div>
  </div>
  <hr class="sphynx-mt-d-2 mb-4 border-current opacity-25" />
  @if (error) {
    <div class="error">{{ error }}</div>
  }
  @if (!isLoading && !error && data) {
    <div>
      <div class="flex flex-wrap -mx-3">
        <div class="w-full lg:w-7/12 px-3 mb-6">
          <div class="bg-white border rounded-md p-6 h-full sphynx-bs">
            <div class="flex flex-col items-center">
              <img src="assets/images/certificate-medal-svgrepo-com.svg" alt="Certificate Badge" style="height: 70px" class="mb-4" />
              <h6 class="text-center text-base font-medium leading-[1.2] mb-2">CERTIFICATION</h6>
              <h2 class="text-[calc(1.325rem+.9vw)] xl:text-[2rem] leading-[1.2] font-bold text-center mb-4">{{ data.training_programme }}</h2>
              <h6 class="text-center text-base font-medium leading-[1.2] mb-2">ISSUED TO</h6>
              <p class="text-center mb-2">
                <span class="font-bold">{{ data.certified_user }}</span
                ><br />
              </p>
              <p class="text-center mb-6">The bearer of this certificate has successfully achieved a fundamental level of {{ data.training_programme }} mastery</p>
              <div class="flex justify-between w-full mt-6">
                <div>
                  <div class="text-sm text-muted">Issued on {{ data.creation_date | date: 'MMMM d, y' }}</div>
                </div>
                <div>
                  <div class="text-sm text-muted">Certificate ID: {{ data.certificate_hash }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-5/12 px-3 mb-6">
          <div class="bg-white border rounded-md p-6 h-full sphynx-bs">
            <div class="mb-12">
              <div class="font-bold mb-2">Issued to</div>
              <div class="flex items-center border rounded-md p-2">
                <img src="assets/images/avatar-boy-svgrepo-com.svg" alt="Calendar Icon" style="height: 30px" class="mr-2" />
                <div>{{ data.certified_user }}</div>
              </div>
            </div>
            <div class="mb-12">
              <div class="font-bold mb-2">Issue date</div>
              <div class="flex items-center border rounded-md p-2">
                <img src="assets/images/calendar-svgrepo-com.svg" alt="Calendar Icon" style="height: 30px" class="mr-2" />
                <div>
                  <div>{{ data.creation_date | date: 'MMMM d, y' }}</div>
                </div>
              </div>
            </div>
            <div>
              <div class="font-bold mb-2">Certification earned</div>
              <div class="flex items-center border rounded-md p-2">
                <img src="assets/images/certificate-svgrepo-com.svg" alt="Certificate Icon" style="height: 50px" class="mr-2" />
                <div>
                  <div>{{ data.training_programme }}</div>
                  <div class="text-sm text-muted">{{ data.programme_duration }} Minutes - {{ data.programme_questions }} Questions</div>
                </div>
                <div class="sphynx-ml-i-2">
                  <span class="inline-block px-[0.65em] py-[0.35em] text-xs font-bold leading-none whitespace-nowrap rounded-md bg-light text-body border ml-2">Cyber Security</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
